jQuery(document).ready(function onMenuNavigation($) {
    "use strict";

    var $menu = $('.menu');

    $menu.find('.menu-item-has-children').on('click', onClickMenuItem);

    function onClickMenuItem(e) {
        var $this = $(this);
        var offset = $this.offset();
        const offsetY = e.clientY - offset.top;
        if(e.target.nodeName.toLowerCase() !== 'a' && offsetY < 30) {
            $this.toggleClass('expanded');
        }
    }
});
